const isAndroidFirefox = () => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('firefox') >= 0) {
    if (agent.indexOf('android') >= 0) {
      return true;
    }
  }
  return false;
};

export { isAndroidFirefox as i };
//# sourceMappingURL=isAndroidFirefox-CzUWluKe-CzUWluKe.js.map
